<template>
	<div>
		<v-card>
			<v-card-title class="py-2 primary">
				<span class="tertiary--text">
					{{ action == 'store' ? 'Aggiungi Cliente' : (action == 'edit' ? 'Modifica Cliente' : 'Visualizza Cliente') }}
				</span>
			</v-card-title>
			<v-card-text class="pt-6">
				<v-form ref="clienteForm">
					<v-row>
						<v-col cols="6" class="pb-0">
							<v-text-field
								v-model="cliente.codice_cliente"
								label="Codice Cliente"
								outlined
								dense
								:readonly="action == 'show'"
							></v-text-field>
						</v-col>
						
						<v-col cols="6" class="pb-0">
							<v-text-field
								v-model="cliente.nome"
								label="Nome"
								outlined
								dense
								:rules="[mixin_rules.required]"
								:readonly="action == 'show'"
							></v-text-field>
						</v-col>
						
						<v-col cols="6" class="pb-0">
							<v-text-field
								v-model="cliente.cognome"
								label="Cognome"
								outlined
								dense
								:rules="[mixin_rules.required]"
								:readonly="action == 'show'"
							></v-text-field>
						</v-col>
						
						<v-col cols="6" class="pb-0">
							<v-text-field
								v-model="cliente.email"
								label="Email"
								outlined
								dense
								:rules="[mixin_rules.required, mixin_rules.email]"
								:readonly="action == 'show'"
							></v-text-field>
						</v-col>
						
						<v-col cols="6" class="pb-0">
							<v-text-field
								v-model="cliente.ragione_sociale"
								label="Ragione sociale"
								outlined
								dense
								:rules="[mixin_rules.required]"
								:readonly="action == 'show'"
							></v-text-field>
						</v-col>
						
						<v-col cols="6" class="pb-0">
							<v-text-field
								v-model="cliente.telefono"
								label="Telefono"
								outlined
								dense
								:rules="[mixin_rules.required]"
								:readonly="action == 'show'"
							></v-text-field>
						</v-col>
						
						<v-col cols="6" class="pb-0">
							<v-select
								:items="tipologieCliente"
								v-model="cliente.tipologia"
								label="Tipologia"
								dense
								outlined
								:readonly="action == 'show'"
								:rules="[mixin_rules.required]"
							></v-select>
						</v-col>
						
						<template v-if="action == 'store' || action == 'edit'">
							<v-col cols="6" class="pb-0">
								<v-file-input
									v-model="files.brochure_personalizzata"
									label="Brochure personalizzata"
									outlined
									dense
									clearable
									accept=".pdf"
									:loading="isLoadingBrochurePersonalizzata"
									:disabled="isLoadingBrochurePersonalizzata"
									truncate-length="35"
									@change="setChanged(files.brochure_personalizzata)"
									@click:clear="cliente.path_brochure_personalizzata = null"
								>
									<template
										v-slot:append
										v-if="files.brochure_personalizzata !== null"
									>
										<v-icon
											class="ml-3"
											@click="viewFileInBrowser(files.brochure_personalizzata)"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-file-input>
							</v-col>
						</template>
						<template v-else-if="action == 'show'">
							<v-col cols="6" class="pb-0">
								<v-text-field
									:value="getFileNameFromPath(cliente.path_brochure_personalizzata)"
									label="Brochure personalizzata"
									outlined
									dense
									readonly
								>
									<template
										v-slot:append
										v-if="cliente.path_brochure_personalizzata !== null"
									>
										<v-progress-circular
											v-if="isGettingFile.brochure_personalizzata"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											@click="getFileAndViewInBrowser(cliente.path_brochure_personalizzata, 'brochure_personalizzata')"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-text-field>
							</v-col>
						</template>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="tertiary"
					@click="close()"
					:disabled="isSaving"
					class="black--text"
				>
					{{ action == 'show' ? 'Chiudi' : 'Annulla'}}
				</v-btn>
				<v-btn
					v-if="action == 'store' || action == 'edit'"
					color="secondary"
					@click="action == 'store' ? store() : (action == 'edit' ? update() : null)"
					:loading="isSaving"
					:disabled="isLoading || isSaving"
				>
					Salva
				</v-btn>
			</v-card-actions>
		</v-card>
	
	</div>
</template>

<script>
import { eventBus } from "@/event-bus";
import {mapActions} from "vuex";
export default {
	props: ['value', 'action'],
	data() {
		return {
			cliente: {},
			isLoadingBrochurePersonalizzata: false,
			files: {
				brochure_personalizzata: null
			},
			isSaving: false,
		}
	},
	
	created() {
		this.cliente = Object.assign({}, this.value || this.clienteVoid);
		if (this.cliente.path_brochure_personalizzata !== null && this.action != 'show') {
			this.getBrochurePersonalizzata()
		}
	},
	
	computed: {
		isLoading() {
			return this.isLoadingBrochurePersonalizzata;
		}
	},
	
	methods: {
		...mapActions({
			showSnackbar: 'systemSnackbar/show'
		}),
		async getBrochurePersonalizzata() {
			this.isLoadingBrochurePersonalizzata = true;
			this.files.brochure_personalizzata = await this.getFile(this.cliente.path_brochure_personalizzata);
			this.files.brochure_personalizzata.changed = false;
			this.isLoadingBrochurePersonalizzata = false;
		},
		store() {
			if (!this.$refs.clienteForm.validate()) return
			this.isSaving = true;
			let formData = new FormData();
			for (let key in this.files) {
				formData.append(`files[${key}]`, this.files[key]);
			}
			formData.append('cliente', JSON.stringify(this.cliente));
			axios.post('/api/clienti', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
					this.$emit('close');
					this.$emit('reload-clienti');
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		update() {
			if (!this.$refs.clienteForm.validate()) return
			this.isSaving = true;
			let formData = new FormData();
			for (let key in this.files) {
				if (this.files[key] !== null) {
					if (this.files[key].hasOwnProperty('changed')) {
						if (this.files[key].changed) formData.append(`files[${key}]`, this.files[key]);
					}
				}
			}
			formData.append('cliente', JSON.stringify(this.cliente));
			axios.patch(`/api/clienti/${this.cliente.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
					this.$emit('close');
					this.$emit('reload-clienti');
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		close() {
			this.$emit('close');
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
	}
}
</script>

<style scoped>

</style>